var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAttention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.245,
    height: 29.244,
    viewBox: "0 0 29.245 29.244",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M33.175,50.524A14.622,14.622,0,1,1,47.8,65.146,14.622,14.622,0,0,1,33.175,50.524",
    transform: "translate(-33.175 -35.902)",
    fill: "#1a1a1a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M45.921,57.476a1.862,1.862,0,0,1,1.877-1.86,1.869,1.869,0,1,1,0,3.737,1.866,1.866,0,0,1-1.877-1.877m3.25-3.446H46.424L46.151,41.7h3.3Z",
    transform: "translate(-33.175 -35.902)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAttention);
export default __webpack_public_path__ + "static/media/iconAttention.45459042de7db7e2caf5e394535ec1c2.svg";
export { ForwardRef as ReactComponent };